module.exports = __webpack_public_path__ + "img/[红包].e03b5783.svg";